import { atom } from 'infrastructure/state/jotai.wrapper'
import { getFlowTag, RootFolderId } from './utility'
import { googleUserAtom, getFileInfo } from 'infrastructure/googleDrive'
import { ContentServiceFlowStatus, RequestError } from '../contentService/types'
import { isRequestError } from '../contentService/utility'

export const presentationFolderAtom = atom(RootFolderId)
export const presentationFolderResetAtom = atom(0)

export const currentFlowTag = atom(async (get) => {
  const folderId = get(presentationFolderAtom)
  if (!folderId) return
  const { result } = await getFlowTag(folderId)
  return result?.flow_tag
})

export const currentStatusAtom = atom<
  { status?: ContentServiceFlowStatus | RequestError } | undefined
>()

export const doesCurrentStatusExistAtom = atom((get) => {
  const status = get(currentStatusAtom)
  return !!status?.status && !isRequestError(status.status)
})

export const currentFolderData = atom((get) => {
  const { credential } = get(googleUserAtom)
  if (!credential) return

  const folderId = get(presentationFolderAtom)
  if (!folderId) return
  return getFileInfo(credential.accessToken, folderId)
})
